import React, { useEffect, useState } from 'react';

import { getAnimation } from 'components/styled/AnimatedStack';
import useFallbackImage from 'hooks/useFallbackImage';
import { Link } from 'react-router-dom';
import { S3_BUCKET_BASE_URL as base } from 'services/common';
import { getLatestEventImages } from 'services/event';
import { mediaLessThan, useWindowSize } from 'utils/media';
import { normalizeForUrl } from 'utils/normalizeForUrl';

import AnimatedStack from 'components/styled/AnimatedStack';
import styled from 'styled-components';
import { StyledSpacing } from '../index.styled';
import { StyledContainer, StyledEventsCamera, StyledTextContainer, StyledTitle } from './index.styled';
import { events } from './mock';

const EventsStack = styled(AnimatedStack)`
  bottom: 0px;
  left: -180px;
  height: 370px;

  @media screen and (max-width: 1100px) {
    height: 230px;
  }
`;

const EventPoster = ({ image, alt, href }) => {
  const { setFallbackImageSource } = useFallbackImage('');
  return (
    <Link rel="noopener" to={href}>
      <img className="landing__event__poster_internship" src={image} alt={alt} onError={setFallbackImageSource} />
    </Link>
  );
};

const WhatDoWeDo = () => {
  const [latestEvents, setLatestEvents] = useState(null);
  useWindowSize();

  useEffect(() => {
    getLatestEventImages({ numberOfEvents: 6 })
      .then(response => {
        setLatestEvents(response.data);
      })
      .catch(() => {
        setLatestEvents(events);
      });
  }, []);

  if (!latestEvents) {
    return null;
  }

  const carouselItems = [...latestEvents, ...latestEvents, ...latestEvents];

  /* ZAKOMENTIRANO JER ĆE MOZDA BIT POTREBNO UBUDUĆE */
  /*const isMobile = mediaLessThan(767);

   const cardWidth = isMobile ? 288 : 384;
  const cardHeight = isMobile ? 176 : 228;
  const cardMargin = isMobile ? 24 : 32; */

  /*const getPosterImagePath = event => {
    if (event.coverImagePath?.folder && event.coverImagePath?.image) {
      return `${base}/images/${event.coverImagePath.folder}/${event.coverImagePath.image}`;
    }
  }; */

  return (
    <StyledContainer>
      <StyledSpacing>
        <StyledTextContainer>
          <StyledTitle>Čime se bavimo u DUMP-u?</StyledTitle>
        </StyledTextContainer>
      </StyledSpacing>
      <StyledEventsCamera>
        {/* ZAKOMENTIRANO JER ĆE MOZDA BIT POTREBNO UBUDUĆE
        <AnimatedCarousel margin={cardMargin} duration={50} direction="left">
           {latestEvents.map(event => (
            <StyledEventLink
              key={event.id}
              to={{
                pathname: `/events/${event.id}-${normalizeForUrl(event.name)}`,
                state: { event },
              }}
            >
              <StyledEventPoster
                alt={`${event.name} image`}
                onError={setFallbackImageSource}
                src={getPosterImagePath(event)}
                width={cardWidth}
                height={cardHeight}
              />
            </StyledEventLink>
          ))}
        </AnimatedCarousel> */}
        <EventsStack
          animation={mediaLessThan(900) ? getAnimation(-290, -480 * 4) : getAnimation(10, -405 * 4)}
          duration="32.05"
          animateOnce
          offset="-1220"
        >
          {carouselItems &&
            carouselItems.map((event, index) => (
              <EventPoster
                key={index}
                image={`${base}/images/${event.posterImagePath.folder}/${event.posterImagePath.image}`}
                alt={`${event.name}`}
                href={{
                  pathname: `/events/${event.id}-${normalizeForUrl(event.name)}`,
                  state: { event },
                }}
              />
            ))}
        </EventsStack>
      </StyledEventsCamera>
    </StyledContainer>
  );
};

export default WhatDoWeDo;
